<!--
 * @Author: Haotian Zheng
 * @Date: 2023-07-13 19:17:15
 * @Descripttion: 
 * @LastEditors: cuicuizi
 * @LastEditTime: 2024-05-16 13:04:28
-->
<!-- header部分 -->
<template>
    <div class="headerBox">
        <div class="header">
            <div class="header_logoBox" @click="toHomePage">
                <img src="../assets/image/header/header_logo.png" alt="" />
            </div>
            <div class="header_tabsBox">
                <router-link class="home_item" to="/" :class="{ 'on': $route.path == '/' }" tag="div">首页</router-link>
                <router-link class="tabs_item" to="/product" tag="div">产品与服务</router-link>
                <router-link class="tabs_item" to="/shoppingMall" tag="div">企服商城</router-link>
                <router-link class="tabs_item" to="/college" tag="div">企服学院</router-link>
                <router-link class="tabs_item" to="/openPlant" tag="div">开放平台</router-link>
            </div>
            <div class="header_rightBox">
                <!-- 未登录 -->
                <div v-if="!token" class="noLogin">
                    <span @click="toLoginPage()">登录</span>
                    <el-button @click="toRegisterPage()" type="primary">立即注册</el-button>
                </div>
                <!-- 已登录 -->
                <div v-else @click="toStagingPage()">
                    <div class="alreadyLogin">
                        <i></i>
                        <span>工作台</span>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {}
    },
    //监听属性 类似于data概念
    computed: {
        token() {
            return window.localStorage.getItem('token')
        },
        tenantId() {
            return window.localStorage.getItem('tenantId')
        }
    },
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        toLoginPage() {
            this.$router.push('/login')
        },
        toRegisterPage() {
            this.$router.push('/register')
        },
        toStagingPage() {
            if (this.tenantId) {
                this.$router.push('/staging')
            } else {
                // this.$router.push('/userDelete')
                this.$router.push('/userDisable')
            }

        },
        toHomePage() {
            this.$router.push('/')
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() { },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.headerBox {
    width: 100%;
    height: 60px;
    background-color: #fff;
    box-shadow: 0px 4px 10px 0px rgba(139, 151, 182, 0.07);

    .header {
        display: flex;
        align-items: center;

        width: 1200px;
        height: 100%;
        margin: 0 auto;

        .header_logoBox {
            width: 122px;
            height: 34px;
            cursor: pointer;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .header_tabsBox {
            display: flex;
            justify-content: space-between;
            margin-left: 93px;
            width: 427px;

            .tabs_item {
                height: 22px;
                font-size: 16px;
                font-family: Alibaba PuHuiTi 2-55 Regular, Alibaba PuHuiTi 20;
                color: #424242;
                line-height: 22px;
                cursor: pointer;

                &:hover {
                    color: #be1a21;
                }

                &.router-link-active {
                    position: relative;
                    color: #be1a21;

                    &::after {
                        position: absolute;
                        bottom: -5px;
                        left: 50%;
                        transform: translateX(-50%);

                        content: '';
                        width: 80%;
                        height: 2px;
                        background: #be1a21;
                        border-radius: 1px;
                    }
                }

            }


            .home_item {
                height: 22px;
                font-size: 16px;
                font-family: Alibaba PuHuiTi 2-55 Regular, Alibaba PuHuiTi 20;
                color: #424242;
                line-height: 22px;
                cursor: pointer;

                &.on {
                    position: relative;
                    color: #be1a21;

                    &::after {
                        position: absolute;
                        bottom: -5px;
                        left: 50%;
                        transform: translateX(-50%);

                        content: '';
                        width: 80%;
                        height: 2px;
                        background: #be1a21;
                        border-radius: 1px;
                    }
                }
            }
        }

        .header_rightBox {
            margin-left: auto;

            .noLogin {
                span {
                    font-size: 16px;
                    font-family: Alibaba PuHuiTi 2-55 Regular, Alibaba PuHuiTi 20;
                    color: #3d3d3d;
                    line-height: 22px;
                    margin-right: 34px;
                    cursor: pointer;
                }

                .el-button {
                    width: 116px;
                    height: 40px;
                    background: #be1a21;
                    font-size: 16px;
                    border-radius: 0px;
                    font-family: Alibaba PuHuiTi 2-55 Regular, Alibaba PuHuiTi 20;
                    color: #ffffff;
                    line-height: 40px;
                }
            }

            .alreadyLogin {
                display: flex;
                align-items: center;
                cursor: pointer;

                i {
                    margin-right: 5px;
                    width: 22px;
                    height: 22px;
                    background-image: url('../assets/image/header/header_stagingIcon.png');
                    background-size: 100% 100%;
                }

                span {
                    height: 22px;
                    font-size: 16px;
                    font-family: Alibaba PuHuiTi 2-55 Regular, Alibaba PuHuiTi 20;
                    color: #3d3d3d;
                    line-height: 22px;
                }
            }
        }
    }
}
</style>
